export default "/images/95442d03a936191d3da622c12828c89d.avif";